<template>
  <b-card
    v-if="imageUrl"
    class="p-2 calllog-details booking_details text-center"
  >
    <img
      :src="imageUrl"
      class="img-fluid"
    >
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
  },

  data() {
    return {
      imageUrl: null,
    }
  },

  created() {
    this.viewFile()
  },
  methods: {
    async viewFile() {
      try {
        const response = await this.$http.get(
          `front-end/file/get/${this.$route.params.id}`,
          {
            responseType: 'blob',
          },
        )

        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        })
        const url = window.URL.createObjectURL(blob)

        if (response.headers['content-type'] === 'application/pdf') {
          window.open(url, '_self')
        } else if (response.headers['content-type'].startsWith('image/')) {
          this.imageUrl = url // Bind this to an <img> tag in your template
        } else {
          // Fallback to download
          this.downloadFile(url, response.headers['content-disposition'])
        }
      } catch (error) {
        let errorMessage = process.env.VUE_APP_DEFAULT_ERROR_MESSAGE

        // Handle different error response types
        if (error.response) {
          if (error.response.data && typeof error.response.data === 'object') {
            errorMessage = error.response.data.message || errorMessage
          } else if (typeof error.response.data === 'string') {
            errorMessage = error.response.data
          }
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: errorMessage,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    downloadFile(url, contentDisposition) {
      const link = document.createElement('a')
      link.href = url

      let fileName = 'file'

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/)
        if (fileNameMatch && fileNameMatch[1]) {
          // eslint-disable-next-line prefer-destructuring
          fileName = fileNameMatch[1]
        }
      }

      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()

      // Clean up
      window.URL.revokeObjectURL(url)
      link.remove()
    },
  },
}
</script>
